import { render } from "./research-equipment-form-view.vue?vue&type=template&id=628efc11&scoped=true&ts=true"
import script from "./research-equipment-form-view.vue?vue&type=script&lang=ts"
export * from "./research-equipment-form-view.vue?vue&type=script&lang=ts"

import "./research-equipment-form-view.vue?vue&type=style&index=0&id=628efc11&lang=scss&scoped=true"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628efc11"]])

export default __exports__